//@ts-nocheck
import React from "react";
import {
  Box,
  Grid,
  Typography,
  Divider,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableContainer,
  TableCell,
  Paper,
  Chip,
  Select,
  MenuItem,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Crop32Rounded } from "@mui/icons-material";

const DecisionLogicReport = (props) => {
  const { currentReports, currentStabilityScore, selectedAccount, handleSelectAccount } = props;

  const statusColors = {
    "-3": "#CC3333",
    "-2": "#CC3333",
    "-1": "#FFBF00",
    "0": "#D0D0D0",
    "1": "#A0A0A0",
    "3": "#00CC00",
  };

  const currentReport =
    selectedAccount?.value !== undefined && selectedAccount?.value !== null
      ? currentReports[selectedAccount.value] || {}
      : {};

  console.log("curr report", currentReport);

  const SectionHeader = ({ title }) => (
    <Typography variant="h6" sx={{ color: "#2F929F", fontWeight: "bold", mt: 1, mb: 2 }}>
      {title}
    </Typography>
  );

  const InfoRow = ({ label, value }) => (
    <Grid container spacing={2} sx={{ mb: 1 }} alignItems={"center"}>
      <Grid item xs={12} sm={6} sx={{ textAlign: "right" }}>
        <Typography sx={{ fontWeight: 600, fontSize: 15, color: "#2F929F" }}>{label}</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography sx={{ fontWeight: 500, fontSize: 17 }} fontFamily="inconsolata">
          {value}
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <Box sx={{ mb: 2 }}>
      {/* Request Section */}
      <SectionHeader title="Request (Information Entered)" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <InfoRow label="Name" value={currentReport.NameEntered} />
          <InfoRow label="Email Address" value={currentReport.EmailAddress} />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoRow label="Institution Name" value={currentReport.InstitutionName} />
          <InfoRow label="Routing Number" value={currentReport.RoutingNumberEntered} />
          <InfoRow label="Account Number" value={currentReport.AccountNumberEntered} />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoRow label="Customer Id" value={currentReport.CustomerIdentifier} />
          <InfoRow label="Request" value={currentReport.RequestCode} />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Response Section */}
      <SectionHeader title="Response (Information Returned by Bank)" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <InfoRow label="Name" value={currentReport.NameFound} />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoRow label="Account Name" value={currentReport.AccountName} />
          <InfoRow label="Account Type" value={currentReport.AccountType} />
          <InfoRow label="Routing Number" value={currentReport.RoutingNumberReturned} />
          <InfoRow
            label="Account Number"
            value={
              <Select
                size="large"
                label={"Select Report"}
                value={selectedAccount?.value ?? ""}
                onChange={(e) =>
                  handleSelectAccount({
                    value: e.target.value,
                    label:
                      currentReports[e.target.value]?.AccountNumberFound ||
                      "No Account Number Found",
                  })
                }
                sx={{ fontFamily: "inconsolata", width: "50%", padding: "10px" }}
              >
                {currentReports.map((report, key) => {
                  return (
                    <MenuItem key={key} value={key}>
                      {report?.AccountNumberFound || "No Account Number Found"}
                    </MenuItem>
                  );
                })}
              </Select>
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoRow
            label="Status"
            value={
              <Chip
                label={currentReport.StatusText}
                sx={{
                  backgroundColor: statusColors[currentReport.Status],
                  color: "white",
                  textTransform: "uppercase",
                  minWidth: 100,
                }}
              />
            }
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Notes Section */}
      <SectionHeader title="Notes" />
      <Grid container>
        <Grid item xs={12} md={12}>
          <Box
            sx={{ p: 2, paddingLeft: 5, width: "100%" }}
            dangerouslySetInnerHTML={{ __html: currentReport.Notes }}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Income Stability Score */}
      <SectionHeader title="Income Stability Score" />
      <Grid container>
        <Grid item xs={12} md={6}>
          <Typography variant="body1">{currentStabilityScore}</Typography>
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Summary Section */}
      <SectionHeader title="Summary" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <InfoRow label="Available Balance" value={currentReport.AvailableBalance} />
          <InfoRow
            label="Withdrawals/Debits"
            value={parseFloat(currentReport.TotalDebits).toFixed(2)}
          />
          <InfoRow
            label="Avg Bal Latest Month"
            value={parseFloat(currentReport.AverageBalance).toFixed(2)}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoRow label="Current Balance" value={currentReport.CurrentBalance} />
          <InfoRow
            label="As of Date"
            value={currentReport.AsOfDate && currentReport.AsOfDate.split("T")[0]}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoRow
            label="Deposits/Credits"
            value={parseFloat(currentReport.TotalCredits).toFixed(2)}
          />
          <InfoRow
            label="Average Balance"
            value={parseFloat(currentReport.AverageBalance).toFixed(2)}
          />
        </Grid>
      </Grid>

      {/* Transaction Table */}

      {currentReport.TransactionAnalysisSummaries?.TransactionAnalysisSummaryWithScores &&
        currentReport.TransactionAnalysisSummaries?.TransactionAnalysisSummaryWithScores.length >
          0 && (
          <TableContainer
            sx={{ boxShadow: "none", overflowX: "auto", mt: 3, background: "#f7f7f7" }}
          >
            <Table aria-label="sticky table">
              <TableHead sx={{ display: "table-header-group", textAlign: "left" }}>
                <TableRow>
                  <TableCell>Description</TableCell>
                  <TableCell>Code</TableCell>
                  <TableCell>Transactions</TableCell>
                  <TableCell>Stability Score</TableCell>
                  <TableCell>Total</TableCell>
                  <TableCell>Transactions Last Month</TableCell>
                  <TableCell>Total Last Month</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentReport.TransactionAnalysisSummaries?.TransactionAnalysisSummaryWithScores?.map(
                  (summary, key) => (
                    <TableRow key={key}>
                      <TableCell>{summary.TypeName}</TableCell>
                      <TableCell>{summary.TypeCode}</TableCell>
                      <TableCell>{summary.TotalCount}</TableCell>
                      <TableCell>{summary.Score}</TableCell>
                      <TableCell>{parseFloat(summary.TotalAmount).toFixed(2)}</TableCell>
                      <TableCell>{summary.RecentCount}</TableCell>
                      <TableCell>{parseFloat(summary.RecentAmount).toFixed(2)}</TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
    </Box>
  );
};

export default DecisionLogicReport;
